var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowGround(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8125 13.8125H12.1875C12.403 13.8125 12.6097 13.8981 12.762 14.0505C12.9144 14.2028 13 14.4095 13 14.625C13 14.8405 12.9144 15.0472 12.762 15.1995C12.6097 15.3519 12.403 15.4375 12.1875 15.4375H0.8125C0.597012 15.4375 0.390349 15.3519 0.237976 15.1995C0.0856026 15.0472 0 14.8405 0 14.625C0 14.4095 0.0856026 14.2028 0.237976 14.0505C0.390349 13.8981 0.597012 13.8125 0.8125 13.8125ZM7.3125 9.07969L9.94744 6.44556L11.0963 7.59444L6.5 12.1908L1.90369 7.59444L3.05256 6.44556L5.6875 9.07969V0H7.3125V9.07969Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGround);
export default __webpack_public_path__ + "static/media/arrow-ground.50590668dcf50fa9ef52b47ac8827d1f.svg";
export { ForwardRef as ReactComponent };